import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AppleAuthDone() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const success = searchParams.get("success");

  useEffect(() => {
    if (success === "true") {
      toast.success("Accesso con Apple effettuato!");
      checkAuth();
      setTimeout(() => {
        navigate("/dashboard", { replace: true });
      }, 500);
    } else {
      toast.error("Errore durante l'accesso con Apple");
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 1500);
    }
  }, [success, navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#E2725B] mx-auto mb-4" />
        <p className="text-[#6A564A]">Completamento accesso Apple...</p>
      </div>
    </div>
  );
}
